import OspreyMessagesCreate from './messages-create'
import OspreyMessagesGetById from './messages-get-by-id'
import OspreyMessagesGetThumbnails from './messages-get-thumbnails'
import OspreyMessagesMetadata from './messages-metadata'
import OspreyMessagesSearch from './messages-search'
import OspreyMessagesSearchSuggestion from './messages-search-suggestion'
import OspreyDeleteDraft from './messages-delete'
import OspreyMessagesUpdate from './messages-update'
import OspreyMessagesFromEmailList from './message-from-emailList'
import OspreyMessagesUniqueName from './messages-unique-name'
import OspreyMessagesCopy from './messages-copy'

export default class Messages {

    create(...arg) {
        return new OspreyMessagesCreate(...arg)
    }

    search(...arg) {
        return new OspreyMessagesSearch(...arg)
    }

    getSearchSuggestion(...arg) {
        return new OspreyMessagesSearchSuggestion(...arg)
    }

    getMetadata(...args) {
        return new OspreyMessagesMetadata(...args)
    }

    getById(...args) {
        return new OspreyMessagesGetById(...args)
    }

    getThumbnails(...arg) {
        return new OspreyMessagesGetThumbnails(...arg)
    }

    deleteDraft() {
        return new OspreyDeleteDraft()
    }

    update(...arg) {
        return new OspreyMessagesUpdate(...arg)
    }

    getFromEmailList(...arg) {
        return new OspreyMessagesFromEmailList(...arg)
    }

    getMessagesUniqueName(...arg){
        return new OspreyMessagesUniqueName(...arg)
    }

    copy(...arg) {
        return new OspreyMessagesCopy(...arg)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/messages/index.js